// src/account/AccountManage.js
import { useState } from 'react';
import apiService from '../services/ApiService';

export default function AccountManage({ userData, wpEmail, onDataUpdate }) {

    // DEBUG - na początku funkcji
    const jwtToken = localStorage.getItem('jwt');



    const [isEditing, setIsEditing] = useState(false);
    const [passwordResetMessage, setPasswordResetMessage] = useState('');
    const [lastPasswordReset, setLastPasswordReset] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deletePassword, setDeletePassword] = useState('');
    const [deleteError, setDeleteError] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        email: '',
        phone: '',
        address: '',
        postcode: '',
        city: '',
        country: 'Polska',
        company_name: '',
        company_nip: '',
        company_address: '',
        company_postcode: '',
        company_city: '',
        company_country: 'Polska'
    });
    const [loading, setLoading] = useState(false);

    const startEditing = () => {
        // Wypełnij formularz aktualnymi danymi
        setFormData({
            name: userData?.name || '',
            surname: userData?.surname || '',
            email: userData?.email || '',
            phone: userData?.phone || '',
            address: userData?.address || '',
            postcode: userData?.postcode || '',
            city: userData?.city || '',
            country: userData?.country || 'Polska',
            company_name: userData?.company_name || '',
            company_nip: userData?.company_nip || '',
            company_address: userData?.company_address || '',
            company_postcode: userData?.company_postcode || '',
            company_city: userData?.company_city || '',
            company_country: userData?.company_country || 'Polska'
        });
        setIsEditing(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleNipChange = (e) => {
        const value = e.target.value.replace(/\D/g, ''); // Tylko cyfry
        if (value.length <= 10) {
            setFormData(prev => ({
                ...prev,
                company_nip: value
            }));
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await apiService.updateUserData(formData);
            setIsEditing(false);
            if (onDataUpdate) {
                onDataUpdate();
            }
            alert('Dane zostały zapisane pomyślnie!');
        } catch (error) {
            alert('Błąd podczas zapisywania danych: ' + error.message);
        } finally {
            setLoading(false);
        }
    };


    const handlePasswordReset = async () => {
        // Sprawdź czy nie wysłano już maila w ostatnich 2 minutach
        const now = Date.now();
        if (lastPasswordReset && (now - lastPasswordReset) < 120000) {
            const remainingTime = Math.ceil((120000 - (now - lastPasswordReset)) / 1000);
            setPasswordResetMessage(`Poczekaj jeszcze ${remainingTime} sekund przed kolejnym wysłaniem maila.`);
            return;
        }

        try {

            const response = await fetch('https://geometryhustlers.pl/wp-json/wp/v2/users/reset-password', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: wpEmail }), // używaj wpEmail
            });

            const data = await response.json();

            if (response.ok) {
                setPasswordResetMessage('Link do zmiany hasła został wysłany na Twój adres email.');
                setLastPasswordReset(now);
                setTimeout(() => setPasswordResetMessage(''), 5000);
            } else {
                setPasswordResetMessage('Wystąpił błąd podczas wysyłania maila resetującego.');
            }
        } catch (error) {
            setPasswordResetMessage('Błąd połączenia z serwerem.');
        }
    };

    const handleDeleteAccount = async () => {
        if (!deletePassword.trim()) {
            setDeleteError('Wpisz swoje hasło aby potwierdzić usunięcie konta.');
            return;
        }

        try {
            setLoading(true);

            const token = localStorage.getItem('jwt');

            if (!token) {
                setDeleteError('Brak tokena autoryzacyjnego. Zaloguj się ponownie.');
                return;
            }

            const response = await fetch('https://geometryhustlers.pl/wp-json/wp/v2/users/delete-account', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ password: deletePassword }),
            });

            const data = await response.json();

            if (response.ok) {
                // Sukces - konto zostało usunięte
                alert('Potwierdzamy usunięcie wszystkich Twoich danych z naszych systemów teleinformatycznych. Zostaniesz wylogowany.');

                // Wyloguj użytkownika
                localStorage.removeItem('jwt');

                // Przekieruj na stronę główną
                window.location.href = '/';
            } else {
                // Błąd z serwera
                setDeleteError(data.message || 'Wystąpił błąd podczas usuwania konta.');
            }
        } catch (error) {
            setDeleteError('Błąd połączenia z serwerem.');
        } finally {
            setLoading(false);
        }
    };







    if (isEditing) {
        return (
            <div className="account-manage">
            <form onSubmit={handleSave} className="edit-form">
            {/* Sekcja "Twoje dane" */}
            <div className="form-section">
            <h3>Twoje dane</h3>
            <div className="form-grid">

            <input type="text" name="name" placeholder="Imię" value={formData.name} onChange={handleInputChange} className="form-input" />
            <input type="text" name="surname" placeholder="Nazwisko" value={formData.surname} onChange={handleInputChange} className="form-input" />
            <input type="email" name="email" placeholder="E-mail" value={formData.email} onChange={handleInputChange} className="form-input" />
            <input type="tel" name="phone" placeholder="Telefon" value={formData.phone} onChange={handleInputChange} className="form-input" />
            <input type="text" name="address" placeholder="Ulica i nr mieszkania" value={formData.address} onChange={handleInputChange} className="form-input" />
            <input type="text" name="postcode" placeholder="Kod pocztowy" value={formData.postcode} onChange={handleInputChange} className="form-input" />
            <input type="text" name="city" placeholder="Miasto" value={formData.city} onChange={handleInputChange} className="form-input" />
            <input type="text" name="country" placeholder="Kraj" value={formData.country} disabled className="form-input" style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />

            </div>
            </div>

            {/* Sekcja "Dane do faktury" */}
            <div className="form-section">
            <h3>Dane do faktury</h3>
            <div className="form-grid">

            <input type="text" name="company_name" placeholder="Nazwa firmy" value={formData.company_name} onChange={handleInputChange} className="form-input" />
            <input type="text" name="company_nip" placeholder="NIP (10 cyfr)" value={formData.company_nip} onChange={handleNipChange} className="form-input" pattern="[0-9]{10}" maxLength={10} inputMode="numeric" />
            <input type="text" name="company_address" placeholder="Adres firmy" value={formData.company_address} onChange={handleInputChange} className="form-input" />
            <input type="text" name="company_postcode" placeholder="Kod pocztowy" value={formData.company_postcode} onChange={handleInputChange} className="form-input" />
            <input type="text" name="company_city" placeholder="Miasto" value={formData.company_city} onChange={handleInputChange} className="form-input" />
            <input type="text" name="company_country" placeholder="Kraj" value={formData.company_country} disabled className="form-input" style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }} />

            </div>
            </div>

            {/* Przyciski */}
            <div className="form-actions">
            <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'ZAPISYWANIE...' : 'ZAPISZ'}
            </button>
            <button
            type="button"
            className="btn-secondary"
            onClick={() => setIsEditing(false)}
            disabled={loading}
            >
            ANULUJ
            </button>
            </div>
            </form>
            </div>
        );
    }



    const deleteModal = showDeleteModal && (
        <div className="modal-overlay" onClick={(e) => {
            // Zamknij modal przy kliknięciu w tło
            if (e.target === e.currentTarget) {
                setShowDeleteModal(false);
                setDeletePassword('');
                setDeleteError('');
            }
        }}>
        <div className="modal-content">
        <h3 className="modal-title">⚠️ Usuń konto</h3>
        <div className="modal-text">
        Konto zostanie <strong>trwale usunięte</strong> wraz ze wszystkimi danymi
        z naszych systemów teleinformatycznych.
        <br/><br/>
        <strong>Ta operacja jest nieodwracalna!</strong>
        </div>

        <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '8px' }}>
        Wpisz swoje hasło aby potwierdzić:
        </label>
        <input
        type="password"
        value={deletePassword}
        onChange={(e) => {
            setDeletePassword(e.target.value);
            setDeleteError('');
        }}
        className="form-input"
        disabled={loading}
        />
        {deleteError && <div style={{ color: '#dc3545', fontSize: '14px', marginTop: '8px' }}>
        {deleteError}
        </div>}
        </div>

        <div className="modal-buttons">
        <button
        onClick={handleDeleteAccount}
        disabled={loading}
        className="modal-btn-danger"
        >
        {loading ? 'USUWANIE...' : 'USUŃ KONTO'}
        </button>
        <button
        onClick={() => {
            setShowDeleteModal(false);
            setDeletePassword('');
            setDeleteError('');
        }}
        disabled={loading}
        className="modal-btn-secondary"
        >
        ANULUJ
        </button>
        </div>
        </div>
        </div>
    );




    // Reszta kodu (widok danych)
    return (
        <div className="account-manage">
        {/* Sekcja "Twoje dane" */}
        <div className="data-section">
        <h3>Twoje dane</h3>
        <div className="data-grid">
        <div className="data-item">
        <span className="label">Imię i nazwisko</span>
        <span className="value">
        {userData?.name && userData?.surname
            ? `${userData.name} ${userData.surname}`
            : '---'
        }
        </span>
        </div>
        <div className="data-item">
        <span className="label">E-mail</span>
        <span className="value">{userData?.email || '---'}</span>
        </div>
        <div className="data-item">
        <span className="label">Telefon</span>
        <span className="value">{userData?.phone || '---'}</span>
        </div>
        <div className="data-item">
        <span className="label">Ulica i nr mieszkania</span>
        <span className="value">{userData?.address || '---'}</span>
        </div>
        <div className="data-item">
        <span className="label">Kod pocztowy</span>
        <span className="value">{userData?.postcode || '---'}</span>
        </div>
        <div className="data-item">
        <span className="label">Miasto</span>
        <span className="value">{userData?.city || '---'}</span>
        </div>
        <div className="data-item">
        <span className="label">Kraj</span>
        <span className="value">{userData?.country || '---'}</span>
        </div>
        </div>
        </div>

        {/* Sekcja "Dane do faktury" */}
        <div className="data-section">
        <h3>Dane do faktury</h3>
        {userData?.company_name || userData?.company_nip ? (
            <div className="data-grid">
            <div className="data-item">
            <span className="label">Firma</span>
            <span className="value">{userData?.company_name || '---'}</span>
            </div>
            <div className="data-item">
            <span className="label">NIP</span>
            <span className="value">{userData?.company_nip || '---'}</span>
            </div>
            <div className="data-item">
            <span className="label">Adres firmy</span>
            <span className="value">{userData?.company_address || '---'}</span>
            </div>
            <div className="data-item">
            <span className="label">Kod pocztowy</span>
            <span className="value">{userData?.company_postcode || '---'}</span>
            </div>
            <div className="data-item">
            <span className="label">Miasto</span>
            <span className="value">{userData?.company_city || '---'}</span>
            </div>
            <div className="data-item">
            <span className="label">Kraj</span>
            <span className="value">{userData?.company_country || '---'}</span>
            </div>
            </div>
        ) : null}
        </div>

        {/* Przyciski akcji */}
        <div className="action-buttons">
        <button className="btn-primary" onClick={startEditing}>ZMIEŃ DANE</button>
        <button className="btn-secondary" onClick={handlePasswordReset}>ZMIEŃ HASŁO</button>

        {/* Komunikat o reset hasła */}
        {passwordResetMessage && (
            <div className={`alert ${
                passwordResetMessage.includes('Błąd') ? 'alert-error' :
                passwordResetMessage.includes('Poczekaj') ? 'alert-warning' :
                'alert-success'
            }`} style={{ marginTop: '15px', textAlign: 'center' }}>
            {passwordResetMessage}
            </div>
        )}

        {/* Link do usunięcia konta */}
        <div style={{ marginTop: '30px', textAlign: 'center' }}>
        <button
        onClick={() => setShowDeleteModal(true)}
        style={{
            background: 'none',
            border: 'none',
            color: '#dc3545',
            textDecoration: 'underline',
            cursor: 'pointer',
            fontSize: '14px'
        }}
        >
        Usuń konto
        </button>
        </div>
        </div>

        {deleteModal}
        </div>
    );
}
